import { processedTemplateContent } from '../../../components/Mailing/utils/processedTemplateContent';
import { sendMail } from '../../../components/Mailing/utils/sendMail';

/**
 * Sends validation emails to owner and pensioners (OWNER_SUPERVISION_VALIDATION, PENSIONER_SUPERVISION_VALIDATION).
 * Shared by confirmPensioner and patchSupervisionStatus.
 *
 * @param {Object} options - The options object.
 * @param {Object} options.supervision - The supervision object.
 * @param {Function} options.dispatchAPI - API dispatch.
 * @param {Function} options.message - Error message handler.
 * @param {Function} options.t - Translation function.
 * @returns {Promise<void>} - A promise that resolves when the emails are sent.
 */
export const sendSupervisionValidationEmails = async ({
  supervision,
  dispatchAPI,
  message,
  t
}) => {
  const customers = [];
  customers.push({
    id: supervision.main_informations.owner.user._id,
    template_type: 'OWNER_SUPERVISION_VALIDATION'
  });

  supervision.pensioners.forEach((pensioner) => {
    customers.push({
      id: pensioner.user._id,
      template_type: 'PENSIONER_SUPERVISION_VALIDATION'
    });
  });

  const mailPromise = customers.map(async (customer) => {
    const { data } = await dispatchAPI('GET', {
      url: `templates-mail/type/${customer.template_type}`
    });

    const content = await processedTemplateContent({
      templateType: customer.template_type,
      templateContent: data[0]?.template_content,
      collectionData: supervision,
      dispatchAPI,
      t
    });

    const newValue = {
      ...data[0],
      recipients: customer.id
    };

    await sendMail({
      value: newValue,
      dispatchAPI,
      message,
      templateType: customer.template_type,
      setIsSubmitting: null,
      editorState: content,
      setIsModalOpen: null,
      documentType: null,
      recordID: null,
      filterID: null,
      filesList: [],
      t
    });
  });

  await Promise.all(mailPromise);
};
